/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstanceWithZone } from "./ForcingSubstanceWithZone";
import {
  ForcingSubstanceWithZoneFromJSON,
  ForcingSubstanceWithZoneFromJSONTyped,
  ForcingSubstanceWithZoneToJSON,
  ForcingSubstanceWithZoneToJSONTyped,
} from "./ForcingSubstanceWithZone";
import type { LocalRainUnitEnum } from "./LocalRainUnitEnum";
import {
  LocalRainUnitEnumFromJSON,
  LocalRainUnitEnumFromJSONTyped,
  LocalRainUnitEnumToJSON,
  LocalRainUnitEnumToJSONTyped,
} from "./LocalRainUnitEnum";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface LocalRain
 */
export interface LocalRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration?: number | null;
  /**
   *
   */
  interpolate?: boolean;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  values: Array<Array<number>>;
  /**
   * m/s is only option for now
   *
   * * `m/s` - meter_per_second
   * * `mm/h` - millimeter_per_hour
   * * `mm/min` - millimeter_per_minute
   */
  units?: LocalRainUnitEnum;
  /**
   *
   */
  constant?: boolean;
  /**
   *
   */
  point: Point;
  /**
   *
   */
  diameter: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstanceWithZone>;
}

/**
 * Check if a given object implements the LocalRain interface.
 */
export function instanceOfLocalRain(value: object): value is LocalRain {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("values" in value) || value["values"] === undefined) return false;
  if (!("point" in value) || value["point"] === undefined) return false;
  if (!("diameter" in value) || value["diameter"] === undefined) return false;
  return true;
}

export function LocalRainFromJSON(json: any): LocalRain {
  return LocalRainFromJSONTyped(json, false);
}

export function LocalRainFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    interpolate: json["interpolate"] == null ? undefined : json["interpolate"],
    values: json["values"],
    units: json["units"] == null ? undefined : LocalRainUnitEnumFromJSON(json["units"]),
    constant: json["constant"] == null ? undefined : json["constant"],
    point: PointFromJSON(json["point"]),
    diameter: json["diameter"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceWithZoneFromJSON),
  };
}

export function LocalRainToJSON(json: any): LocalRain {
  return LocalRainToJSONTyped(json, false);
}

export function LocalRainToJSONTyped(
  value?: Omit<LocalRain, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    interpolate: value["interpolate"],
    values: value["values"],
    units: LocalRainUnitEnumToJSON(value["units"]),
    constant: value["constant"],
    point: PointToJSON(value["point"]),
    diameter: value["diameter"],
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceWithZoneToJSON),
  };
}
